import React, { FC, PropsWithChildren, ReactNode } from 'react';
import './module.scss';

export type MainSectionProps = PropsWithChildren<{
    title?: string;
    actions?: ReactNode;
    gap?: string | number;
}>;

export const MainSection: FC<MainSectionProps> = (props: MainSectionProps) => {
    const { title, actions, children, gap } = props;

    return (
        <main className={'main-section'}>
            <div className={'header'}>
                <p className={'main-section-title'}>{title}</p>
                <div className={'main-section-actions'}>{actions}</div>
            </div>

            <div className={'body'} style={{ gap }}>
                {children}
            </div>
        </main>
    );
};
